import { Form } from 'antd';
import styles from './searchGroup.less?modules';
// import SelectML from '@/components//SelectML';
import SingInputML from '@/components/input_all_ml/form_sing_input_ml/SingInputML';
import DatePickerML from '@/components/input_all_ml/date_picker_search_ml/DatePickerSearchML';
import ButtonML from '@/components/button_ml/ButtonML';
const SearchGroup = (props) => {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    for (let key in values) {
      if (!values[key]) {
        values[key] = undefined;
      }
    }
    props.handleSearch(values);
  };

  const onAdd = () => {
    form.resetFields();
    props.onAdd('add');
  };
  const onReset = () => {
    form.resetFields();
    props.onReset();
  };

  return (
    <Form
      form={form}
      name="control-hooks"
      onFinish={onFinish}
      className={styles.serarchFrom}
    >
      {/* 会员号 */}
      {/* <Col span={8}> */}
      <div className={styles.input_contain}>
        {/* 决策图名称 */}
        {/* <SelectML
          height="37px"
          maxWidth="170px"
          labelwidth="130px"
          labelVal="决策图名称"
          placeVal="请选择"
          name="diagramName"
          option={props.options}
          allowClear={true}
          // value={props.value}
        /> */}
        <SingInputML
          height="37px"
          labelwidth="130px"
          maxWidth="170px"
          labelVal="决策图名称"
          placeVal="请输入决策图"
          name="diagramName"
          allowClear={true}
        />

        {/* 创建时间(起始) */}
        <DatePickerML
          height="37px"
          labelwidth="130px"
          labelVal="创建时间(起始)"
          placeVal="请选择开始时间"
          name="createTimeBegin"
          inputWidth="170px"
        />

        {/* 创建时间(结束) */}
        <DatePickerML
          height="37px"
          labelwidth="130px"
          labelVal="创建时间(结束)"
          placeVal="请选择结束时间"
          name="createTimeEnd"
          inputWidth="170px"
        />
      </div>

      <div className={styles.btn_contain}>
        <ButtonML size="large" value="查询" htmlType="submit" fontsize="16px" />
        <ButtonML
          size="large"
          value="重置"
          htmlType="submit"
          fontsize="16px"
          onClick={onReset}
        />
        <ButtonML
          size="large"
          value="新增决策图"
          fontsize="16px"
          onClick={onAdd}
        />
      </div>
    </Form>
  );
};

export default SearchGroup;
